import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function AlertConfirm(props) {
  return (
    <SvgIcon {...props}>
      <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
        <path fillRule="evenodd" d="m19.3 17.3c0.6 0.6 0.2 1.7-0.7 1.7h-13.2c-0.9 0-1.3-1.1-0.7-1.7l1.3-1.3v-5c0-3.1 1.6-5.6 4.5-6.3v-0.7c0-0.8 0.7-1.5 1.5-1.5 0.8 0 1.5 0.7 1.5 1.5v0.7c2.9 0.7 4.5 3.2 4.5 6.3v5zm-9.3 2.7h4c0 1.1-0.9 2-2 2-1.1 0-2-0.9-2-2zm-5.9-10.3c0 0.5-0.5 0.8-0.9 0.8-0.7 0-1.1-0.5-1-1.1 0.3-2.4 1.5-4.5 3.2-6.1 0.4-0.4 1-0.4 1.4 0 0.4 0.4 0.4 1.1 0 1.4-1.4 1.3-2.4 3-2.7 5zm17.8-0.4c0.1 0.7-0.4 1.2-1 1.2-0.5 0-0.9-0.3-1-0.8-0.3-2-1.3-3.7-2.6-5-0.5-0.3-0.5-1-0.1-1.4 0.4-0.4 1-0.4 1.4 0 1.7 1.6 2.9 3.7 3.3 6zm-7.1 0.9l-3.7 3.7-1.7-1.8c-0.3-0.3-0.8-0.3-1.1 0l-0.1 0.1q-0.1 0.1-0.1 0.2-0.1 0.2-0.1 0.3 0 0.2 0.1 0.3 0 0.2 0.1 0.3l2.4 2.3c0.3 0.3 0.8 0.3 1.1 0l4.2-4.2c0.3-0.3 0.3-0.8 0-1.1l-0.1-0.1c-0.3-0.3-0.7-0.3-1 0z" />
      </svg>
    </SvgIcon>
  );
}
